const PaginationNumbers = ({
  paginationData,
  offsetCount,
  setOffsetCount,
}) => {

  const moveTo = (e, callback) => {
    const parent = e.currentTarget.parentElement.parentElement.parentElement;
    const rect = parent.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo({
      top: rect.top + scrollTop,
    });

    if (typeof callback === 'function') {
      callback();
    }
  };

  return (
    <nav className="pagination__numbers">
      {paginationData.has_prev_page && (
        <button onClick={(e) => moveTo(e, () => setOffsetCount(offsetCount - 20))}>
          {paginationData.current_page - 1}
        </button>
      )}
      <button className="active">{paginationData.current_page}</button>
      {paginationData.has_next_page && (
        <button onClick={(e) => moveTo(e, () => setOffsetCount(offsetCount + 20))}>
          {paginationData.current_page + 1}
        </button>
      )}
    </nav>
  );
};

export default PaginationNumbers;
